module.exports = __webpack_public_path__ + "PC/img/noCoupon.10f44659.png";